import { chakra, JsxStyleProps } from '@chakra-ui/react';
import * as React from 'react';
import { PropsApi } from './props';

export interface FlexItemProps {
  alignSelf?: JsxStyleProps['alignSelf'];
  order?: JsxStyleProps['order'];
  overflow?: JsxStyleProps['overflow'];
  overflowX?: JsxStyleProps['overflowX'];
  overflowY?: JsxStyleProps['overflowY'];
  flex?: JsxStyleProps['flex'];
  flexGrow?: JsxStyleProps['flexGrow'];
  flexShrink?: JsxStyleProps['flexShrink'];
  flexBasis?: JsxStyleProps['flexBasis'];
  width?: JsxStyleProps['width'];
  height?: JsxStyleProps['height'];
  position?: JsxStyleProps['position'];
  top?: JsxStyleProps['top'];
  right?: JsxStyleProps['right'];
  bottom?: JsxStyleProps['bottom'];
  left?: JsxStyleProps['left'];
  zIndex?: JsxStyleProps['zIndex'];
}

export interface BoxProps extends FlexItemProps, PropsApi {
  className?: string;
  as?: React.ElementType;
  children?: React.ReactNode;
  chakracss?: JsxStyleProps['css'];
}

type Props = React.ComponentProps<'div'> & BoxProps;

export const Box = React.forwardRef<HTMLDivElement, Props>(function Box(props, ref) {
  const {
    chakracss,
    bg,
    marginX,
    marginY,
    m,
    mt,
    mr,
    mb,
    ml,
    mx,
    my,
    paddingX,
    paddingY,
    p,
    pt,
    pr,
    pb,
    pl,
    px,
    py,
    ...rest
  } = props;

  return React.createElement(chakra.div, {
    ref,
    ...rest,
    css: {
      background: bg,
      margin: m,
      marginLeft: ml ?? mx ?? marginX,
      marginRight: mr ?? mx ?? marginX,
      marginTop: mt ?? my ?? marginY,
      marginBottom: mb ?? my ?? marginY,
      padding: p,
      paddingLeft: pl ?? px ?? paddingX,
      paddingRight: pr ?? px ?? paddingX,
      paddingTop: pt ?? py ?? paddingY,
      paddingBottom: pb ?? py ?? paddingY,
      ...chakracss,
    },
  });
});
